// @flow
import React from 'react';

import RitualLoadingImage from '_images/loading-ritual-white.gif';

import styles from './index.module.less';

const FullPageSpinner = (): React$Node => (
  <div className={styles.FullPageSpinner}>
    <img src={RitualLoadingImage} alt="Ritual Loading.." />
  </div>
);

export default FullPageSpinner;
